import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import { NavController, LoadingController, ToastController } from '@ionic/angular';

import { AccountService } from '../../../api/account.service';
import { AppSettings } from 'src/app/app-settings';

@Component({
  selector: 'app-company',
  templateUrl: './company.page.html',
  styleUrls: ['./company.page.scss'],
})
export class CompanyPage implements OnInit {

  public companyForm: FormGroup;  
  public regions:string[]=["Unspecified", "All", "Africa", "Americas", "Asia","Europe", "Oceania"];
  public currentCompany : {};

  isWeb = AppSettings.IS_WEB;
  
  constructor(
    private accountService: AccountService, 
    private navCtrl: NavController,
    private formBuilder: FormBuilder,
    private loadingCtrl: LoadingController,
    private toastCtrl: ToastController,
  ) {
  }

  ngOnInit() {    
    this.companyForm = this.formBuilder.group({
      'name': [null, null],
      'website': [null, Validators.compose([
        Validators.maxLength(200),
      ])],
      'phone': [null, Validators.compose([
        Validators.maxLength(50),
      ])],
      'region': [null, null],
      'address': [null, Validators.compose([
        Validators.maxLength(200),
      ])],
    });
  }

  async ionViewWillEnter() {
    let t = this;

    const loader = await this.loadingCtrl.create({
      message : 'Loading...'
    })

    loader.present();

    this.accountService.myCompany()
    .then(response => {
      t.currentCompany = response;
      t.loadData(); 
      loader.dismiss();     
    })
    .catch(async (error) => {  
      if (error.status !== 403) { 
        t.navCtrl.pop();
        const toast = await t.toastCtrl.create({
          message: 'Something went wrong.Please try again later.',
          duration: 3000,
          showCloseButton: true,
          position: 'bottom',
          color: 'warning',
        })
        toast.present();
      }    
    })
    .finally(() => {
      loader.dismiss();
    })
  }

  loadData() {
    this.companyForm.patchValue({
      'name': this.currentCompany["name"],
      'website': this.currentCompany["website"],
      'phone': this.currentCompany["phone"],
      'address': this.currentCompany["address"],
      'region': !!this.currentCompany["region"] ? this.currentCompany["region"].charAt(0).toUpperCase() + this.currentCompany["region"].slice(1) :  this.regions[0],
    })
  }

  cancel() {
    this.loadData();
    this.toastCtrl.dismiss().catch(() => {
      //Do nothing, only occurs when there is no toast present
    });
  }

  async saveCompany() {
    const loader = await this.loadingCtrl.create({
      message : 'Saving...'
    })

    loader.present();

    let t = this;

    let company = {
      'name': this.companyForm.get('name').value,
      'website': !!this.companyForm.get('website').value ? this.companyForm.get('website').value : '',
      'phone' : !!this.companyForm.get('phone').value ? this.companyForm.get('phone').value : '', 
      'region': this.companyForm.get('region').value !== "Unspecified" ? this.companyForm.get('region').value.toLowerCase() : '',
      'address' : !!this.companyForm.get('address').value ? this.companyForm.get('address').value : ''
    }

    this.accountService.myCompany(company, true)
    .then(async (response) => {
      t.currentCompany = response;
      t.loadData();
      loader.dismiss();

      t.toastCtrl.dismiss().catch(() => {
        //Do nothing, only occurs when there is no toast present
      });

      const toast = await t.toastCtrl.create({
        message: "Company successfully updated",
        duration: 1000,
        showCloseButton: true,
        position: 'bottom',
        color: 'light',
      });
      toast.present();
    })
    .catch(async(errorResponse) => {
      let error = errorResponse.error

      let errorMsg = "";

      Object.keys(error).forEach(key => {
        errorMsg += key + " : ";

        error[key].forEach((errorCause, index) => {
          errorMsg += index > 0 ? '. ' + errorCause : errorCause
        });
      })

      const toast = await t.toastCtrl.create({
        message: errorMsg,
        duration: 3000,
        showCloseButton: true,
        position: 'bottom',
        color: 'warning',
      })

      loader.dismiss();
      toast.present();
    });
  }

  goToProfile() {
    this.navCtrl.navigateBack("/tabs/tab4");
  }

}
